import {
  getState,
  setForm,
  updateForm,
  removeForm,
  formsSelector,
  onlyIfForm,
} from '../../../store.js'
import ConfirmModal from '../../../common/components/Modal/ConfirmModal.js'
import TextArea from '../../../common/components/TextArea.js'
import apiverson from '../../../common/apiverson.js'
import {showMessageToast} from '../../Header/Toast/index.js'
import {batchSelector, updateBatch} from '../../../data/batches.js'

const MODAL_FORM = 'add_batch_comment_modal'

export function showAddBatchCommentModal(referenceID) {
  setForm(MODAL_FORM, {
    referenceID,
    comment: '',
    isSaving: false,
    serverError: null,
  })
}

export function updateModalForm(updates) {
  updateForm(MODAL_FORM, updates)
}

export function close() {
  removeForm(MODAL_FORM)
}

export function modalFormSelector(state) {
  return formsSelector(state)[MODAL_FORM]
}

export async function addBatchComment() {
  try {
    updateModalForm({isSaving: true})

    const {referenceID, comment} = modalFormSelector(getState())

    const {json} = await apiverson.post(
      `/batch/${encodeURIComponent(referenceID)}/comment`,
      {comment},
    )

    const {comments} = batchSelector(getState(), {referenceID})

    if (comments) {
      updateBatch(referenceID, {comments: [json, ...comments]})
    }

    showMessageToast('Batch comment was added.')

    close()
  } catch (err) {
    updateModalForm({
      serverError: `Error creating Batch comment: ${
        err.message || err.error_message
      }`,
      isSaving: false,
    })
  }
}

function AddBatchCommentModal({form}) {
  return (
    <ConfirmModal
      title="Add Batch Comment"
      confirmText="Save"
      cancelText="Cancel"
      onConfirm={() => addBatchComment()}
      onCancel={() => close()}
      isSaving={form.isSaving}
      error={form.serverError}
    >
      <ul className="list list--no-style">
        <li className="list__item--form list__item--no-style divider--bottom">
          <div className="fs-01">
            <strong>{form.referenceID}</strong>
          </div>
        </li>
        <li>
          <TextArea
            label="Comment"
            rows="10"
            id="comment"
            value={form.comment}
            onChange={(value) => updateModalForm({comment: value})}
            autoFocus
          />
        </li>
      </ul>
    </ConfirmModal>
  )
}

export default onlyIfForm(AddBatchCommentModal, modalFormSelector)
